import { render } from "./Toolbar.vue?vue&type=template&id=de50483a"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"

import exportComponent from "/media/doevent/Data/doevent/project/pmb/db/de-db-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__